import React, { useEffect, useState, useRef, useMemo } from 'react';
import Loader from '../../CustomComponents/Loader';
import { useDispatch, useSelector } from 'react-redux';
import { appTheme, retrieveData } from '../../../helpers/utils/Utils';
import { GetApiHeadersWithBearer, PostRequest } from '../../../network/NetworkUtils';
import { STATUS_SUCCESS_CODE, CANCEL_ALL_UPCOMING_TRANSACTIONS } from '../../../network/URLConstants';
import HomeLayout from '../../Layout/HomeLayout';
import HomeHeader from '../../CustomComponents/HomeHeader';
import DynamicCard from '../../CustomComponents/DynamicCard';
import { width } from '../../CustomComponents/DynamicCard/DynamicCardStyles';
import { formatDateToMonthDayYear, addLineBreaks } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { useNavigate, useLocation } from 'react-router-dom';
import CustomAlertModel from '../../CustomComponents/CustomAlertModel';
import { withOidcSecure } from '@axa-fr/react-oidc'
import Modal from '../../CustomComponents/Modal';
import moment from 'moment';
import TermsArrow from '../../../assets/images/terms_arrow.png';
import left_arrow_green from '../../../assets/images/left_arrow_green.png';
import report_a_problem_flag from '../../../assets/images/report_a_problem_flag.png';
import ToolTipQuestionMark from '../../../assets/images/tooltip_question.png';
import dollorRecuuring from '../../../assets/images/dollor_reccuring.png'
import Dollor_Tick from '../../../assets/images/dollor_tick.png';
import CustomDatePicker from './../../CustomComponents/CustomDateInput';
import { useDocumentTitle } from '../../../hooks/useDocumentTitle';
import kudzu_logo_kudzuplus from '../../../assets/kudzu-plus-images/greenLogo.png';


const LocalClickableTooltip = ({ text, children }) => {
    const [isVisible, setIsVisible] = useState(false);
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);

    const handleClick = () => {
        setIsVisible(!isVisible);
    };

    return (
        <button
            type="button"
            className="relative inline-block"
            onClick={handleClick}
            aria-label="Toggle tooltip"
            aria-expanded={isVisible}
        >
            {children}
            {isVisible && (
                <div className={`z-30 tooltip w-[125px] h-[86px] ${kudzuPlusTrue ? 'bg-[#3C66FF] text-white' : 'bg-[#D6E2E8] text-[#262B3A]'} font-hanken-grotesk font-[700] text-[9px] leading-[13px] text-left p-3 rounded-xl absolute top-[150%] left-1/2 transform -translate-x-1/2 transition-opacity duration-300 opacity-100`}>
                    {kudzuPlusTrue ? <div className="tooltip-arrow-comparion"></div> : <img src={appThemeData.tooltipArrowForNotification} alt="" aria-hidden="true" className='absolute -top-[8px] left-0' />}
                    {text}
                </div>
            )}
        </button>
    );
};


const TransactionCard = (props) => {
    const { hideLayout, Radius } = props

    const location = useLocation();
    const pageSize = location.pathname === '/home' ? 5 : 10;

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { t } = useTranslation();
    const accessTokenToApi = useSelector(state => state.accessToken);
    const transactionDetails = useSelector(state => JSON.parse(state.cancelTransactionDetails));
    const [isLoading, setIsLoading] = useState(false);
    const [showModel, setShowModel] = useState(false);
    const HighlightMsgStyles = "font-serif-pro modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal text-[var(--modal-text-highlight)] cursor-pointer pointer-events-none";
    const HeaderMsgStyles = "font-serif-pro text-[var(--modal-text-heading-clr)] modal-title lg:text-[32px] md:text-[28px] sm:text-[23px] text-[27px] lg:leading-[38px] md:leading-[32px] sm:leading-[30px] leading-[31px] font-normal cursor-pointer pointer-events-none";
    const SubHeaderMsgStyles = "font-hanken-grotesk text-[var(--modal-text-heading-clr)] modal-title lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px] font-normal cursor-pointer pointer-events-none";
    const styleAll = `font-hanken-grotesk  lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[500] break-words text-[var(--text-clr-transactions)]`;
    const styleCategoryLabel = `font-hanken-grotesk  lg:text-[16px] md:text-[15px] sm:text-[14px] text-[16px] leading-[18px] font-[300] break-words`;
    const [highlightMsg, setHighlightMsg] = useState('')
    const [headerMsg, setheaderMsg] = useState('')
    const [subHeaderMsg, setSubHeaderMsg] = useState('')
    const [btn1Exists, setBtn1Exists] = useState(false)
    const [btn2Exists, setBtn2Exists] = useState(false)
    const [btn1Text, setBtn1Text] = useState(false)
    const [btn2Text, setBtn2Text] = useState('')
    const [modelImage, setModelImage] = useState('')
    const [btn1TypeAcpt, setBtn1TypeAcpt] = useState(false)
    const [footerMsg, setFooterMsg] = useState('');
    const [btn1Focus, setBtn1Focus] = useState(false);
    const [btn2Focus, setBtn2Focus] = useState(false);
    const [isBorderNone, setisBorderNone] = useState(true);
    const isMobile = window.innerWidth < 768
    const kudzuPlusTrue = useSelector(state => state.kudzuPlusTrue);
    const appThemeData = appTheme(kudzuPlusTrue);

    useDocumentTitle(t('page_title_transaction_details'));

    const HeadingStyles =
        "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-highlight)]";
    const HeadingUpdatedStyles =
        "font-serif-pro modal-title sm:text-[18px] lg:text-[32px] md:text-[28px] text-[25px] sm:leading-[24px] lg:leading-[38px] md:leading-[33px] leading-[31px] font-normal text-[var(--modal-text-heading-clr)]"
    const continueButtonClasses = `font-hanken-grotesk sm:font-bold font-[600] lg:text-[18px] md:text-[17px] sm:text-[13px] text-[14px] text-[#2965FB] cursor-pointer  flex items-center`;


    const [isOpenContuneStopModal, setIsOpenContinueStopModal] = useState(false);
    const [stopRecurringSuccessModal, setStopRecurringSuccessModal] = useState(false);
    const [editableEndDate, setEditableEndDate] = useState(null);
    const editableEndDateRef = useRef(null);
    const userHasSelectedEndDateRef = useRef(false);
    const currencySymbolMap = { USD: '$', EUR: '€', GBP: '£' };
    const currencySymbol = currencySymbolMap[transactionDetails?.CurrencyCode] || transactionDetails?.CurrencyCode || '$';
    const amountPrefix = transactionDetails?.DrCrIndicator === 'Cr' ? '+' : transactionDetails?.DrCrIndicator === 'Dr' ? '-' : '';

    useEffect(() => {
        editableEndDateRef.current = editableEndDate;
    }, [editableEndDate]);

    useEffect(() => {
        if (userHasSelectedEndDateRef.current) return;
        if (transactionDetails?.EndDate && transactionDetails?.EndDate !== "Not Specified") {
            const apiEndDate = new Date(transactionDetails.EndDate);
            setEditableEndDate(apiEndDate);
            editableEndDateRef.current = apiEndDate;
        } else {
            setEditableEndDate(null);
            editableEndDateRef.current = null;
        }
    }, [transactionDetails?.EndDate]);


    useEffect(() => {
        userHasSelectedEndDateRef.current = false;
    }, [transactionDetails?.TransactionId]);

    const endDateDisabledDates = useMemo(() => {
        const start = transactionDetails?.StartDate ? moment(transactionDetails.StartDate).startOf('day') : moment().startOf('day');
        const dates = [];
        for (let i = 0; i <= 365; i++) {
            dates.push(moment(start).subtract(i, 'day').toDate());
        }
        return dates;
    }, [transactionDetails?.StartDate]);


    const closeContinueModal = () => {
        setIsOpenContinueStopModal(false)
    }

    const openStopeRecurringSuccessModal = () => {
        setIsOpenContinueStopModal(false)
        setCurrentStep(2)
    }



    const closeModel = () => {
        if (btn1Text == t('back_to_account')) {
            setShowModel(false);
            navigate('/Spending')
        } else {
            setShowModel(false);
        }
    }


    const showAlertModal = (showModel, highlightMsg, headerMsg, subHeaderMsg, btn1Exists, btn2Exists, btn1Text, btn2Text, btn1TypeAcpt, modelImage, footerMsg, btn1Focus, btn2Focus, isBorderNone) => {
        setShowModel(showModel)
        setHighlightMsg(highlightMsg)
        setheaderMsg(headerMsg)
        setSubHeaderMsg(subHeaderMsg)
        setBtn1Exists(btn1Exists)
        setBtn2Exists(btn2Exists)
        setBtn1Text(btn1Text)
        setBtn2Text(btn2Text)
        setBtn1TypeAcpt(btn1TypeAcpt)
        setModelImage(modelImage)
        setFooterMsg(footerMsg)
        setBtn1Focus(btn1Focus)
        setBtn2Focus(btn2Focus)
        setisBorderNone(isBorderNone)
    }
    const onCancelBtnClick = () => {
        if (btn2Text == t('cancel_series')) { closeModel() }
        else if (btn2Text == t('cancel_next_transfer')) { closeModel() }
        else if (btn2Text == t('cancel_transfer')) { closeModel() }
        else { closeModel() }
    }
    const onAcptBtnClick = () => {
        if (btn1Text == t('cancel_series')) {
            closeModel();
            onCancelTransferOneTime(t('cancel_series'))
        }
        else if (btn1Text == t('cancel_next_transfer')) {
            closeModel();
            onCancelTransferOneTime(t('cancel_next_transfer'))
        }
        else if (btn1Text == t('cancel_transfer')) {
            closeModel();
            onCancelTransferOneTime(t('cancel_transfer'))
        }
        else if (btn1Text == t('back_to_account')) {
            dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('ActivityTab') } });
            closeModel();
            navigate("/Spending");
        }
        else {
            closeModel()
        }
    }

    const onCancelTransfer = async (type) => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        const TransactionId = transactionDetails?.TransactionId
        const object = {}
        const cardKey = transactionDetails?.cardDetails?.CardKey
        let url = `/api/cardholders/upcoming/transaction/${TransactionId}/cancel/${cardKey}/true`;
        const endDateToSend = editableEndDateRef.current ?? editableEndDate;
        if (endDateToSend) {
            url += `?endDate=${moment(endDateToSend).format('YYYY-MM-DD')}`;
        }
        setIsLoading(true)
        const response = await PostRequest(url, object, headers)
        setTimeout(() => {
            setIsLoading(false)
        }, 500);
        const responseObj = JSON.parse(response)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setStopRecurringSuccessModal(true)
        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("oops"), '', displayText, true, false, t('back_to_account'), '', true, require('../../../assets/images/illo_transaction_cancel.png'), '', true, false)
            return
        }
    };

    const onCancelTransferOneTime = async (type) => {
        const deviceId = await retrieveData('updatedDeviceId');
        const headers = await GetApiHeadersWithBearer(deviceId, accessTokenToApi);
        let url
        const object = {}
        const cardKey = transactionDetails?.cardDetails?.CardKey
        if (type == t('cancel_series')) {
            url = CANCEL_ALL_UPCOMING_TRANSACTIONS.replace('{transactionId}', transactionDetails?.TransactionId) + `?cardKey=${cardKey}&all=true`
        } else if (type == t('cancel_next_transfer')) {
            url = CANCEL_ALL_UPCOMING_TRANSACTIONS.replace('{transactionId}', transactionDetails?.TransactionId) + `?cardKey=${cardKey}&all=false`
        } else if (type == t('cancel_transfer')) {
            url = CANCEL_ALL_UPCOMING_TRANSACTIONS.replace('{transactionId}', transactionDetails?.TransactionId) + `?cardKey=${cardKey}&all=true`
        }
        setIsLoading(true)
        const response = await PostRequest(url, object, headers)
        setTimeout(() => {
            setIsLoading(false)
        }, 500);
        const responseObj = JSON.parse(response)
        if (responseObj.ResponseCode == STATUS_SUCCESS_CODE) {
            setTimeout(() => {
                if (type == t('cancel_series')) {
                    showAlertModal(true, t("success"), isMobile ? addLineBreaks(t("this_scheduled_transfer_series_cancelled_mobile")) : addLineBreaks(t("this_scheduled_transfer_series_cancelled")), '', true, false, t('back_to_account'), '', true, require('../../../assets/images/illo_transaction_cancel.png'), '', true, false)
                } else if (type == t('cancel_next_transfer')) {
                    showAlertModal(true, t("success"), isMobile ? addLineBreaks(t("this_upcoming_transfer_cancelled_mobile")) : addLineBreaks(t("this_upcoming_transfer_cancelled")), '', true, false, t('back_to_account'), '', true, require('../../../assets/images/illo_transaction_cancel.png'), '', true, false)
                } else {
                    showAlertModal(true, t("success"), isMobile ? addLineBreaks(t("your_transfer_cancelled_mobile")) : addLineBreaks(t("your_transfer_cancelled")), '', true, false, t('back_to_account'), '', true, require('../../../assets/images/illo_transaction_cancel.png'), '', true, false)
                }
            }, 1000);
        } else {
            var arrMessages = responseObj.Messages;
            var message = arrMessages[0];
            var displayText = message.DisplayText;
            showAlertModal(true, t("oops"), '', displayText, true, false, t('back_to_account'), '', true, require('../../../assets/images/illo_transaction_cancel.png'), '', true, false)
            return
        }
    }

    const handleReportAProblem = () => {
        showAlertModal(true, isMobile ? t("need_to") : '', isMobile ? t("we_r_here_to_help") : addLineBreaks(t("need_to_here_to_help")), <p>{t("call")} <span className='font-[600px] text-[var(--modal-text-highlight)]'>{t('1-855-751-0025')}</span> {t('to_report')} <span className='font-[600px] text-[var(--modal-text-highlight)] cursor-pointer pointer-events-auto' onClick={() => navigate('/Help/ContactUs')} >{t('customer_care')}</span> {t('team_to_help')}</p>, true, true, t('back_to_account'), t('cancel'), true, require('../../../assets/images/illo-report.png'), '', false, true, true)
    }

    const getHeaderText = () => {
        return (
            <>
                {(addLineBreaks(t('here_are_details_for_transaction')))}
            </>
        )
    };
    const [currentStep, setCurrentStep] = useState(1);

    const displayValue = `${transactionDetails.cardDetails.NickName} ..${transactionDetails.cardDetails.CardDisplayNumber.slice(-4)}`;

    // Logic to swap From/To fields based on credit/debit
    const isCredit = transactionDetails?.DrCrIndicator === 'Cr';
    const merchantName = transactionDetails?.MerchantName || transactionDetails?.RetailerName || "---";
    const fromValue = isCredit ? merchantName : displayValue;
    const toValue = isCredit ? displayValue : merchantName;

    const closeStopRecurringSucessModal = () => {
        setStopRecurringSuccessModal(false)
    }

    const backToManageRecurringPayments = () => {
        navigate('/Spending')
    }

    return (
        <div>
            <>
                <HomeLayout>
                    <>
                        <HomeHeader heading={
                            <>
                                <div className='flex sm:hidden'>
                                    <div onClick={() => {
                                        dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('UpcomingTab') } });
                                        navigate('/Spending');
                                    }} className='mb-5 text-[14px] cursor-pointer font-[600] font-hanken-grotesk flex items-center'>
                                        <img src={left_arrow_green} alt='leftArrow' className='mr-1' />
                                        <span className='text-[#559C7E]'>{t('back')}</span>
                                    </div>
                                </div>
                                {getHeaderText()}
                            </>

                        } isHeaderCaption={true} />
                    </>
                    <div className='flex flex-col lg:w-[860px] md:w-[860px] sm:w-[464px] w-[100%]
          animate__animated animate__fadeInRight '>
                        <>
                            <DynamicCard
                                header={false}
                                footer={true}
                                CardRadius={true}
                                cardWidth={width.homeCard}
                                HeaderRadius={true}
                                backgroundColor={kudzuPlusTrue ? '--cardHeading-bg' : '--onbaord-navbar-bg'}
                                isWhite={appThemeData.isWhiteBgForCard}
                                isDarkForKudzu={appThemeData.isDarkBgForCard}
                                HeaderContent={
                                    <div className='sm:block hidden'>
                                        <div className='sm:flex block justify-between flex-nowrap items-center md:my-[45px] sm:my-[25px] my-[20px] md:mx-[4%] sm:ml-[6%] sm:mr-[8%] mr-[2.5rem] ml-[2.5rem] cursor-pointer'>
                                            <div onClick={() => {
                                                dispatch({ type: 'SELECTED_CARD_TAB', payload: { selectedCardTab: t('UpcomingTab') } });
                                                navigate('/Spending');
                                            }} className='lg:text-[20px] md:text-[18px] sm:text-[14px] text-[16px]  cursor-pointer text-white font-[500] md:font-[500] font-hanken-grotesk flex items-center'>
                                                <img src={TermsArrow} alt='leftArrow' style={{ filter: 'brightness(0) invert(1)' }} className='mr-1' />
                                                <span>{isMobile ? displayValue.slice(0, 13) : displayValue.slice(0, 23)}</span>
                                            </div>
                                        </div>
                                    </div>
                                } >

                                {

                                    <>
                                        <div className='md:pb-[9rem] pb-[5rem] mt-[48px] sm:px-0 px-4'>
                                            <div className='mb-5'>
                                                <p className={`font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[13px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('transaction')}</p>
                                            </div>
                                            <div className='flex flex-row sm:items-center justify-between w-full'>

                                                <div className={`flex justify-center gap-2 items-center ${styleAll}`}>
                                                    <div className='transactionCategoryIcon'>
                                                        <img src={transactionDetails?.IconUri} alt="Icon" className='h-[14px]' />
                                                    </div>
                                                    <div>
                                                        <p>{transactionDetails?.Description}</p>
                                                        <p className='block sm:hidden font-hanken-grotesk text-[#A0A5B3] lg:text-[13px] md:text-[13px] sm:text-[13px] text-[14px] font-[300] mt-1 opacity-[50%]'>{transactionDetails?.Category}</p>
                                                    </div>
                                                </div>
                                                <div className={`hidden sm:block text-center ${styleCategoryLabel} ${kudzuPlusTrue ? "text-[#A0A5B3]" : "text-[#5E667B]"}`}>
                                                    <p>{transactionDetails?.Category}</p>
                                                </div>
                                                <div className={`${styleAll}`}>
                                                    <p className={`flex justify-end ${transactionDetails?.DrCrIndicator === 'Cr' ? 'text-[#30BC89]' : ''}`}>{amountPrefix} {currencySymbol} {Math.abs(parseInt(transactionDetails?.Amount))}.{(Math.abs(transactionDetails?.Amount) % 1).toFixed(2).slice(2)}</p>
                                                </div>
                                            </div>
                                            <div className='border-b-[2.5px] opacity-50 border-[var(--transactions-acc-number-border)] mt-6 relative left-1/2 -translate-x-1/2 lg:w-[860px] md:w-[860px] sm:w-[464px] w-full'></div>

                                            <div class="flex justify-center flex-col items-center">
                                                {(transactionDetails.StatusCode === 'APP' || transactionDetails.Status === 'Pending') && (
                                                    <div class="w-full flex justify-between items-center">
                                                        <p className={`my-7 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>Status</p>
                                                        <p className={`${styleAll}`}>{t('pending')}</p>
                                                    </div>
                                                )}
                                                <div class={`w-full flex justify-between items-center ${(transactionDetails.StatusCode === 'APP' || transactionDetails.Status === 'Pending') ? "border-t" : ""} border-[var(--transactions-acc-number-border)]`}>
                                                    <p className={`my-7 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('from')}</p>
                                                    <p className={`${styleAll} flex items-center justify-end gap-2`}>
                                                        {!isCredit && <img src={kudzu_logo_kudzuplus} alt="kudzu icon" className="w-3 h-3 object-contain" />}
                                                        <span>
                                                            {(fromValue ?? "").slice(0, isMobile ? 13 : 23)}
                                                        </span>
                                                    </p>
                                                </div>

                                                <div className='w-full flex justify-between items-center border-t border-[var(--transactions-acc-number-border)]'>
                                                    <p className={`my-7 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>
                                                        {t("To")}
                                                    </p>
                                                    <p className={`my-7 ${styleAll} flex items-center justify-end gap-2`}>
                                                        {isCredit && <img src={kudzu_logo_kudzuplus} alt="kudzu icon" className="w-3 h-3 object-contain" />}
                                                        <span>
                                                            {(toValue ?? "").slice(0, isMobile ? 13 : 23)}
                                                        </span>
                                                    </p>
                                                </div>


                                                <div className="w-full flex justify-between  items-center border-t border-[var(--transactions-acc-number-border)]">
                                                    <p className={`my-7 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>{t('amount')}</p>
                                                    <p className={`my-7 ${styleAll}`}>{amountPrefix} {currencySymbol} {Math.abs(parseInt(transactionDetails?.Amount))}.{(Math.abs(transactionDetails?.Amount) % 1).toFixed(2).slice(2)}</p>
                                                </div>
                                                <div className="w-full flex justify-between items-center border-t border-[var(--transactions-acc-number-border)]">
                                                    <p className={`my-7 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>Category</p>
                                                    <p className={`my-7 ${styleAll}`}>{transactionDetails.Category}</p>
                                                </div>
                                                <div className="w-full flex justify-between items-center border-t border-[var(--transactions-acc-number-border)]">
                                                    <p className={`my-7 font-hanken-grotesk uppercase lg:text-[13px] md:text-[13px] sm:text-[11px] text-[10px] font-[600] tracking-[2px] ${kudzuPlusTrue ? "text-[#779CE5]" : "text-gray-400"}`}>Date</p>
                                                    <p className={`my-7 ${styleAll}`}>{formatDateToMonthDayYear(transactionDetails.TransactionTime)}</p>
                                                </div>

                                                <div class="w-full sm:mt-6 mt-2">
                                                    <>
                                                        <div className="  flex flex-row cursor-pointer items-center mb-14" onClick={() => { handleReportAProblem() }}>
                                                            <img onClick={() => { handleReportAProblem() }} src={report_a_problem_flag} className='w-[10px] h-[12px] sm:w-[11px] sm:h-[14px] mr-3' alt="arrow" />
                                                            <p className="font-hanken-grotesk text-[14px] leading-[14px] sm:font-[700] sm:text-[12px] sm:leading-[20px] font-[600] md:text-[16px] md:leading-[24px] text-[#2965FB]"
                                                                tabIndex={0}
                                                                onClick={() => { handleReportAProblem() }}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === "Enter") {
                                                                        event.preventDefault();
                                                                        handleReportAProblem()
                                                                    }
                                                                }}
                                                            >{t('report_a_problem')}</p>
                                                        </div>
                                                    </>
                                                </div>

                                            </div>
                                        </div>
                                    </>
                                }
                            </DynamicCard>
                        </>
                    </div>
                </HomeLayout>
            </>
            <>
                {showModel &&
                    <CustomAlertModel
                        isOpen={showModel}
                        onClose={closeModel}
                        image={modelImage}
                        highlightMsg={isMobile ? <span className={HighlightMsgStyles}>{highlightMsg}</span> : <p className={HighlightMsgStyles}>{highlightMsg}</p>}
                        HeaderMsg={isMobile ? <span className={HeaderMsgStyles}>{headerMsg}</span> : <p className={HeaderMsgStyles}>{headerMsg}</p>}
                        subHeaderMsg={<p className={SubHeaderMsgStyles}>{subHeaderMsg}</p>}
                        btn1Exists={btn1Exists}
                        btn2Exists={btn2Exists}
                        btn1Text={btn1Text}
                        btn2Text={btn2Text}
                        btn1TypeAcpt={btn1TypeAcpt}
                        footerMsg={<p className={SubHeaderMsgStyles}>{footerMsg}</p>}
                        onAcptBtnClick={onAcptBtnClick}
                        onCancelBtnClick={onCancelBtnClick}
                        // showErrorImg={showErrorImg}
                        isBorderNone={isBorderNone}
                        btn1Focus={btn1Focus}
                        btn2Focus={btn2Focus}
                    />
                }
            </>

            {isOpenContuneStopModal && (
                <Modal
                    isOpen={isOpenContuneStopModal}
                    onClose={closeContinueModal}
                    defaultCornerRadius={false}
                    isLogo={false}
                    Fullheight={true}
                    title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Are you sure?</span></p>}
                    subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                            {t('CONTINUE_MODAL_SUB_HEADING')}
                        </span>}
                    content={
                        <div className=' flex flex-col justify-center items-center w-full'>
                            <div className="flex items-start gap-2">
                                <img src={appThemeData.OopsIcon} alt="oops" className="md:w-[20px] md:h-[20px] sm:w-[14px]
                    sm:h-[14px] w-[15px] h-[15px] mt-1 sm:mt-0 md:mt-1  self-start" />
                                <p className={`font-hanken-grotesk lg:text-[16px] md:text-[16px] sm:text-[16px] text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[var(--modal-text-heading-clr)]`}>{t('CONFIRM_CANCEL_TRANSACTION_SUB_HEADING')}</p>
                            </div>

                            <img src={dollorRecuuring} alt="complete" className='lg:w-[120px] md:w-[100px] sm:w-[92px] w-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                            <p className={`font-hanken-grotesk lg:text-[16px] md:text-[16px] sm:text-[16px] text-[14px] font-[400] sm:font-[500] leading-[24px] sm:leading-[22px] md:leading-[28px] text-[var(--modal-text-heading-clr)] lg:mb-[30px] md:mb-[40px] sm:mb-[40px] mb-[40px]`}>{t('CONFIRM_MODAL_FOOTER_TEXT')}</p>
                            <div className="w-full flex justify-between items-center mt-6">
                                <button
                                    type="button"
                                    className={continueButtonClasses}
                                    onClick={closeContinueModal}
                                >
                                    {t('Cancel')}
                                </button>

                                <button
                                    type="button"
                                    className={continueButtonClasses}
                                    onClick={openStopeRecurringSuccessModal}
                                >
                                    {t('Continue')}
                                    <img
                                        src={appThemeData.SignupNextArrow}
                                        className={` 
                                     ml-2`}
                                        alt=""
                                    />
                                </button>
                            </div>
                        </div>
                    }
                />
            )}

            {/* Stop Recurring Success modal */}
            {stopRecurringSuccessModal && (
                <Modal
                    isOpen={stopRecurringSuccessModal}
                    onClose={closeStopRecurringSucessModal}
                    defaultCornerRadius={false}
                    isLogo={false}
                    Fullheight={true}
                    title={<p className={HeadingUpdatedStyles}><span className={HeadingStyles}>Okay!</span></p>}
                    subHeaderMsg={
                        <span className={HeadingUpdatedStyles}>
                            {t('This recurring payment has been stopped successfully.')}
                        </span>}
                    content={
                        <div className=' flex flex-col justify-center items-center w-full'>
                            <div className="flex flex-col gap-20 justify-center mb-[0px]">
                                <div className="flex flex-col justify-center items-center w-full">

                                </div>
                            </div>
                            <img src={Dollor_Tick} alt="complete" className='lg:w-[250px] md:w-[100px] sm:w-[92px] w-[100px] lg:h-[250px] md:h-[100px] sm:h-[92px] h-[100px] lg:my-1 md:my-14 sm:my-10 my-10' />
                            <div className=' flex flex-col justify-center items-center gap-8 w-full'>
                                <button class="font-hanken-grotesk lg:text-[18px] md:text-[17px] 
                                         sm:text-[15px] text-[16px] font-[500] sm:font-bold leading-[24px] sm:leading-[12px] md:leading-[16px] bg-[#2965FB] text-white cursor-pointer border-2 px-2 py-4 border-[#2965FB] w-full"
                                    onClick={backToManageRecurringPayments}
                                >Back to Account</button>
                            </div>
                        </div>
                    }
                />
            )}

            {isLoading && <Loader />}
        </div >
    );
};

export default withOidcSecure(TransactionCard);
